import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { notification } from 'antd';
import qs from 'qs';
import { removeUserFromStorage } from '../../utils/users';

const InitialPage = (): JSX.Element => {
  const navigate = useNavigate();
  const locationObject = useLocation();

  useEffect(() => {
    // Redirect each role user to defined pages
    if (locationObject.pathname === '' || locationObject.pathname === '/') {
      const queryString = qs.parse(locationObject.search, { ignoreQueryPrefix: true });

      if (queryString['session'] === 'expired') {
        notification.warning({
          message: 'Atenção',
          description: 'Login expirado. Por favor, entre novamente.',
        });

        removeUserFromStorage();
        navigate('/login');
      }

      navigate('/home');
    }
  }, []);

  return (<div>InitialPage</div>);
};

InitialPage.propTypes = {};
InitialPage.defaultProps = {};

export default InitialPage;
